import React from 'react'

import bg from '../assets/imgs/bg_catalog.webp';

export const Gratitude = () => {
    // setTimeout(() => {
    //   window.location.href = "/"
    // }, 4000);
  return (
    <section className="wrapper_catalogos">
      <article className="drawer_home"> 
        <div className="container-gratitude">
          <div className="container-gratitude-img" style={{ backgroundImage: `url(${bg})` }}>
          </div>
          <div className="container-gratitude-info">
            <h1 className="container-gratitude-info-title">Gracias</h1>
            <h2 className="container-gratitude-info-subtitle">Contáctanos</h2>
            <div className="container-gratitude-info-email">
              <a href="mailto:hola@redcompanies.com.mx" target="_blank">hola@redcompanies.com.mx</a>
            </div>
            <div className="container-gratitude-info-address">
              <p>Ac 26 #85D 55 Ofc. A125C,</p>
              <p>Bogotá, D.C.</p>
            </div>
            <div className="container-gratitude-info-site">
              <p className="m-0">
                <a target="_blank" href="https://wa.me/+525632018306">
                  <span>
                    <i className={"fab fa-whatsapp"}></i> +52 (563) 201 8306
                  </span>
                </a>
              </p>
            </div>
          </div>
        </div>
      </article>
    </section>
  )
} 